<template>
  <section class="home-split-newfiles">
    <div class="title">合作伙伴</div>
    <div class="current-file ad-list" ref="rDom1">
      <el-carousel>
        <el-carousel-item v-for="(item1, index) in list1" :key="index">
          <img class="adImg" :src="item1.photoUrl">
        </el-carousel-item>
      </el-carousel>
      <!-- <div class="title">{{currentStr + '月实施新规'}}</div>
      <div class="file-list-wrap">
        <fileSimpleCard v-for="(item, index) in newList1" :key="index" :cardData="item"></fileSimpleCard>
      </div>
      <el-pagination
        :page-size="5"
        @current-change="handleCurrentChange1"
        layout="prev, pager, next"
        :total="tatal1"
        v-if="tatal1 > 5">
      </el-pagination> -->
    </div>
    <div class="next-file ad-list" ref="rDom2">
      <el-carousel>
        <el-carousel-item v-for="(item2, index) in list2" :key="index">
          <img class="adImg" :src="item2.photoUrl">
        </el-carousel-item>
      </el-carousel>
      <!-- <div class="title">{{nextStr + '月及以后实施新规'}}</div>
      <div class="file-list-wrap">
        <fileSimpleCard v-for="(item, index) in newList2" :key="index" :cardData="item"></fileSimpleCard>
      </div>
      <el-pagination
        :page-size="5"
        @current-change="handleCurrentChange2"
        layout="prev, pager, next"
        :total="tatal2"
        v-if="tatal2 > 5">
      </el-pagination> -->
    </div>
  </section>
</template>

<script>
import api from '../../../api/index'
import { Loading } from 'element-ui'
// import fileSimpleCard from '@/components/fileSimpleCard.vue'
export default {
  data () {
    return {
      activeName: 'first',
      newList1: [],
      tatal1: 0,
      newLoading1: true,
      newList2: [],
      tatal2: 0,
      newLoading2: true,
      nowTime: new Date(),
      list1: [],
      list2: []
    }
  },
  mounted () {
    this.doGetFileRank()
    // this.getList1(1)
    // this.getList2(1)
  },
  methods: {
    handleCurrentChange1 (val) {
      this.getList1(val)
    },
    getList1 (pageNo) {
      this.newLoading1 = true
      api.getRecommendList({
        pages: 5,
        pageNo,
        implementTimeStart: this.currentMonth(),
        implementTimeEnd: this.nextMounth()
      }).then(res => {
        this.newLoading1 = false
        if (res && res.code === 200) {
          this.newList1 = res.data.list
          this.tatal1 = res.data.totalNumber
        }
      })
    },
    handleCurrentChange2 (val) {
      this.getList2(val)
    },
    getList2 (pageNo) {
      this.newLoading2 = true
      api.getRecommendList({
        pages: 5,
        pageNo,
        implementTimeStart: this.nextMounth()
      }).then(res => {
        this.newLoading2 = false
        if (res && res.code === 200) {
          this.newList2 = res.data.list
          this.tatal2 = res.data.totalNumber
        }
      })
    },
    currentMonth (val) {
      const y = this.nowTime.getFullYear()
      const m = this.nowTime.getMonth() + 1
      if (m < 10) {
        return y + '-0' + m + '-01'
      } else {
        return y + '-' + m + '-01'
      }
    },
    nextMounth (val) {
      const y = this.nowTime.getFullYear()
      const m = (this.nowTime.getMonth() + 2) % 12 || 12
      if (m < 10) {
        return y + (m === 1 ? 1 : 0) + '-0' + m + '-01'
      } else {
        return y + '-' + m + '-01'
      }
    },
    // 左侧广告
    doGetFileRank () {
      api.noticeAdvertising({
      }).then(res => {
        if (res && res.code === 200) {
          this.list1 = res.data.list1
          this.list2 = res.data.list2
        }
      })
    }
  },
  computed: {
    currentStr () {
      const m = this.nowTime.getMonth() + 1
      return m
    },
    nextStr () {
      const m = (this.nowTime.getMonth() + 2) % 12 || 12
      return m
    }
  },
  watch: {
    newLoading2 (val) {
      if (val) {
        this.loadingInstance = Loading.service({
          target: this.$refs.rDom2,
          fullscreen: false
        })
      } else {
        this.loadingInstance && this.loadingInstance.close()
      }
    },
    newLoading1 (val) {
      if (val) {
        this.loadingInstance = Loading.service({
          target: this.$refs.rDom1,
          fullscreen: false
        })
      } else {
        this.loadingInstance && this.loadingInstance.close()
      }
    }
  },
  components: {
    // fileSimpleCard
  }
}
</script>

<style lang="scss">
.home-split-newfiles {
  .current-file {
    // transform: translateY(10%);
    .title {
      font-size: 18px;
      color: #409eff;
    }
  }
  .next-file {
    // transform: translateY(10%);
    .title {
      border-top: 1px solid #efefef;
      color: #409eff;
      margin-top: 12px;
      padding-top: 12px;
    }
  }
  .el-tabs__header {
    margin-bottom: 6px;
  }
  .el-pager li {
    min-width: 24px;
  }
  .title {
    height: 72px;
    line-height: 72px;
    font-size: 32px;
    margin: 12px 0 0;
    text-align: center;
    font-weight: bolder;
  }
  .ad-list {
    .el-carousel__container {
      height: calc((100vh - 300px - 80px - 32px) / 2);
      .adImg {
        height: 100%;
        width: 100%;
        object-fit: contain;
      }
    }
  }
}
</style>
